module.exports = __webpack_public_path__ + "static/media/image3@3x.d2df75d1.png";